export const BRAND_CODE = 'NG';
export const SITE_CODE = 'NG';
